.ugc-radio-wrapper {
  display: flex;
  font-size: 16px;
  color: #333;
  label {
    margin: 0;
  }
  .container {
    flex: 1;
    display: block;
    position: relative;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  .container input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
  }

  .check-mark {
    position: absolute;
    top: 10px;
    left: 0;
    height: 20px;
    width: 20px;
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 50%;
    transition: all linear 0.15s;
    @at-root [dir='rtl'] & {
      right: 0;
    }
  }

  .container:hover input ~ .check-mark {
    background-color: #fff;
  }

  .container input:checked ~ .check-mark {
    border: 1px solid #458500;
    background-color: #458500;
  }

  .check-mark:after {
    content: '';
    position: absolute;
    display: none;
  }

  .container input:checked ~ .check-mark:after {
    display: block;
  }

  .container .check-mark:after {
    top: 5px;
    left: 5px;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: white;
  }
}
